// extracted by mini-css-extract-plugin
export default {"container":"imageUploader_container__fffZ4","box":"imageUploader_box__QDJoD","uploader":"imageUploader_uploader__RsQp3"};